import React, { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import { useAuth } from './AuthContext';
import { DEFAULT_VOCABULARY } from '../constants/defaultVocabulary';

const VocabularyContext = createContext(DEFAULT_VOCABULARY);

const fetchVocabulary = async () => {
  const response = await api.get('/api/tenant-context/vocabulary');
  return response.data?.terms || {};
};

export const VocabularyProvider = ({ children }) => {
  const { user } = useAuth();

  const { data } = useQuery({
    queryKey: ['vocabulary', user?.current_tenant_id],
    queryFn: fetchVocabulary,
    enabled: !!user?.current_tenant_id,
    staleTime: Infinity,
  });

  const dict = data ?? DEFAULT_VOCABULARY;

  return (
    <VocabularyContext.Provider value={dict}>
      {children}
    </VocabularyContext.Provider>
  );
};

export const useLabel = (key, fallback) => {
  const dict = useContext(VocabularyContext);
  return dict[key] ?? fallback ?? DEFAULT_VOCABULARY[key] ?? key;
};

export default VocabularyContext;
